export function recruitFunc() {
  fixInterviewWheelScroll();
}

/**
 * インタビュースライダー上で縦ホイールがページスクロールを奪う問題を解消。
 * 横スクロールコンテナ（overflow-x:auto）は縦ホイールを横スクロールへ変換して
 * 消費するため、縦操作のときは明示的にページをスクロールさせる。
 */
function fixInterviewWheelScroll() {
  const wrap = document.querySelector('.p-recruit-interview__track-wrap');
  if (!wrap) return;

  wrap.addEventListener(
    'wheel',
    function (e) {
      if (Math.abs(e.deltaY) > Math.abs(e.deltaX)) {
        e.preventDefault();
        window.scrollBy({ top: e.deltaY, left: 0 });
      }
    },
    { passive: false }
  );
}
